import { ca } from '@cian/analytics';

export function trackPreInfiniteEmptyShow() {
  ca('event', {
    action: 'show_emptysearch_banner',
    category: 'Listing',
    name: 'oldevent',
  });
}
